import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconBinLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={fill}
        d="M7.308 20.5a1.74 1.74 0 0 1-1.277-.531 1.74 1.74 0 0 1-.531-1.277V6h-.25a.725.725 0 0 1-.534-.216.726.726 0 0 1-.216-.534c0-.213.072-.391.216-.535A.725.725 0 0 1 5.25 4.5H9a.85.85 0 0 1 .259-.626.852.852 0 0 1 .625-.259h4.232c.244 0 .453.087.625.259A.853.853 0 0 1 15 4.5h3.75c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534.722.722 0 0 1-.216.534.726.726 0 0 1-.534.216h-.25v12.692c0 .497-.177.923-.531 1.277a1.74 1.74 0 0 1-1.277.531H7.308ZM17 6H7v12.692a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h9.385a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V6Zm-6.846 11c.213 0 .39-.072.534-.215a.727.727 0 0 0 .216-.535v-7.5a.726.726 0 0 0-.216-.535.726.726 0 0 0-.535-.215.725.725 0 0 0-.534.215.727.727 0 0 0-.215.535v7.5c0 .212.072.39.216.535a.727.727 0 0 0 .534.215Zm3.693 0c.212 0 .39-.072.534-.215a.727.727 0 0 0 .215-.535v-7.5a.726.726 0 0 0-.216-.535.727.727 0 0 0-.534-.215.726.726 0 0 0-.534.215.727.727 0 0 0-.216.535v7.5c0 .212.072.39.216.535a.726.726 0 0 0 .535.215Z"
      />
    </Svg>
  );
};

export default IconBinLine;
